import React from 'react';
import { Modal, Button } from 'react-bootstrap';

function ConfirmModal({ show, handleClose, onConfirm, title, message, confirmText = "Confirmar", cancelText = "Cancelar", variant = "primary" }) {
    const handleConfirm = () => {
        onConfirm();
        handleClose();
    };

    return (
        <Modal size="sm" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="mb-3">{message}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {cancelText}
                </Button>
                <Button variant={variant} onClick={handleConfirm}>
                    {confirmText}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmModal;